import { render, staticRenderFns } from "./createModoPagamento.vue?vue&type=template&id=2c1d8729&scoped=true&"
import script from "./createModoPagamento.vue?vue&type=script&lang=js&"
export * from "./createModoPagamento.vue?vue&type=script&lang=js&"
import style0 from "./createModoPagamento.vue?vue&type=style&index=0&id=2c1d8729&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1d8729",
  null
  
)

export default component.exports